import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IPurchaseInvoicesItemsResponse } from "@api/stores/purchaseInvoices/items/types";

import type { IPathBaseParam, IPathByIdParam } from "./path";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IPurchaseInvoicesItemsResponse>>,
  IPathBaseParam,
  IPaginationParams
>("stores.purchaseInvoices.items");
const getApis = createGetApi<
  IApiResponse<IPurchaseInvoicesItemsResponse>,
  IPathByIdParam,
  object
>("stores.purchaseInvoices.items");

export const items = {
  ...getAllApis,
  ...getApis,
};
